import styled, { css } from 'styled-components'

import { orientation } from '@/constants/focus'

export const ScrollbarContainer = styled.div<{
  $activeIndex: number
  $length: number
  $orientation: orientation
}>`
  display: flex;
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  padding: ${({ $orientation }) =>
    $orientation === orientation.HORIZONTAL ? '0 20px' : '20px 0'};
  border-radius: 22px;
  ${({ $orientation }) =>
    $orientation === orientation.HORIZONTAL ? 'height: 44px;' : 'width: 44px;'}

  ul {
    overflow: hidden;
    list-style: none;
    display: flex;
    flex-direction: ${({ $orientation }) =>
      $orientation === orientation.HORIZONTAL ? 'row' : 'column'};

    ${({ $length, $orientation }) => {
      const size = $length === 5 ? 116 : 108

      return $orientation === orientation.HORIZONTAL
        ? css`
            max-width: ${size}px;
          `
        : css`
            max-height: ${size}px;
            width: 100%;
          `
    }}

    flex-wrap: nowrap;
    padding: 0;
    margin: 0;
    align-items: center;
  }

  li {
    flex: 0 0 auto;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    position: relative;
    margin: 6px;
    transition: 0.3s all;
    background: #fff;
    opacity: 0.5;

    &:first-child {
      ${({ $orientation }) =>
        $orientation === 'vertical' ? 'margin-top: 0;' : 'margin-left: 0;'}
    }

    &:last-child {
      ${({ $orientation }) =>
        $orientation === 'vertical' ? 'margin-bottom: 0;' : 'margin-right: 0;'}
    }

    transform: ${({ $activeIndex, $length, $orientation }) => {
      const isVertical = $orientation === 'vertical'

      if ($length < 6) {
        return isVertical ? 'translateY(0)' : 'translateX(0)'
      }
      const areCorneringDotsSmall =
        $activeIndex > 1 && $activeIndex < $length - 2
      const offset = areCorneringDotsSmall ? -4 : 0
      const hiddenStartDotCount = Math.max(
        0,
        Math.min($activeIndex, $length - 3) - 2,
      )
      const smallDotSize = 16
      const translateAmount = -(hiddenStartDotCount * smallDotSize + offset)
      return isVertical
        ? `translateY(${translateAmount}px)`
        : `translateX(${translateAmount}px)`
    }};

    &.is-active {
      pointer-events: none;
      width: 20px;
      height: 20px;
      opacity: 1;
      background-color: #fff;
    }

    &.is-small {
      width: 4px;
      height: 4px;
    }
  }
`
